export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/realistic_drawing.22bcf74.png";